module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/home/hero-cycle/hero-image-1.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/home/hero-cycle/hero-image-1.jpg
// module id = VIZW
// module chunks = 0